import { el, mount, unmount } from 'redom';

import application from 'application';
import serverInterface from 'server-interface';

import AudioControls from '../audio-controls';
import VideoControls from '../video-controls';

class ProducerMode {

  constructor(meeting, onLiveModeActivated) {

    const user = application.getUser();

    this.meeting = meeting;
    this.onLiveModeActivated = onLiveModeActivated;

    this.userProfileDisplay = el('.user-profile-display', {
      style: {
        backgroundImage: `url(${user.profilePicture.url})`
      }
    });
    this.videoDisplay = el('video.video-display');
    this.displayContainer = el('.video-display-container', this.userProfileDisplay);

    this.audioControls = new AudioControls(true, user._id, this.meeting);
    this.videoControls = new VideoControls({ height: 253 });

    this.controlsContainer = el('.controls-container', [this.audioControls, this.videoControls]);

    this.hiddenContainer = el('.hidden-container', { style: { opacity: 0, zIndex: -1 } }, []);

    this.mediaContentContainer = el('.media-content-container', [this.displayContainer, this.controlsContainer]);

    this.producerModeContent = el('.producer-mode-content', [this.mediaContentContainer]);

    this.el = el('.created-view-producer-mode', [this.producerModeContent, this.hiddenContainer]);

    this.registerEventListeners();
    this.initializeDisplay();

  }

  onunmount() {

  }

  registerEventListeners() {

    this.videoControls.el.addEventListener('camera-stream-started', this.handleVideoStreamStarted.bind(this));
    this.videoControls.el.addEventListener('camera-stream-stopped', this.handleVideoStreamStopped.bind(this));

  }

  handleVideoStreamStarted(event) {

    unmount(this.displayContainer, this.userProfileDisplay);
    mount(this.displayContainer, this.videoDisplay);

    this.videoDisplay.srcObject = event.detail.stream;

    this.videoDisplay.onloadedmetadata = function(e) {
      this.videoDisplay.play();
    }.bind(this);

  }

  handleVideoStreamStopped() {

    unmount(this.displayContainer, this.videoDisplay);
    mount(this.displayContainer, this.userProfileDisplay);

  }

  async handleGoLiveButtonClick() {

    const ensured = await application.devicesManager.ensureMediaPermissions();

    if (ensured === false) {
      return;
    }

    await this.activateLiveView();

  }

  initializeDisplay() {

  }

  async activateLiveView() {

    const internalEventCodes = await import('event-system/codes/internal');
    const postId = this.meeting.postId;

    try {

      await serverInterface.startup.community.singleProducerMeeting.startSingleProducerMeetingByPostId(postId);
      await serverInterface.startup.community.singleProducerMeeting.trySetMeetingLiveStatusToConnected(postId, application.getInstanceId());

      this.onLiveModeActivated();

    } catch (exception) {

      let message = 'Unknown error! If repeated, kindly contact administration';

      if (exception.code === 'TWO_MEETINGS_ON_ONE_BROWSER_WINDOW') {
        message = 'You are already in another meeting. Please end the current meeting first.';
      }

      application.eventSystem.internal.emit(internalEventCodes.default.DISPLAY_SYSTEM_TOAST_MESSAGE, {
        message,
        seconds: 5,
        type: 'error'
      });

    }

  }

}

export default ProducerMode;